<script>
    import FieldText from "./FieldText"
    export default {
        name: 'FieldEmail',
        extends: FieldText,
        props: {
            type: {
                type: String,
                default: 'email'
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldEmail.vue